const styles = () => ({
  root: {
    maxWidth: '60vw',
    width: 710,
  },

  header: {
    borderBottom: '1px solid #E1E6EB',
    marginBottom: 24,
  },

  headerImage: {
    height: 240,
    width: '100%',
  },

  title: {
    fontWeight: 600,
    fontSize: 24,
    marginBottom: 6,
    color: '#27282A',
  },

  newsDetail: {
    minHeight: '100vh',
    overflowY: 'scroll',
    display: 'flex',
    flexFlow: 'column nowrap',
  },

  timeago: {
    fontSize: 16,
    color: '#596168',
    fontWeight: 'normal',
    marginTop: 6,
    marginBottom: 24,
  },

  body: {
    position: 'relative',
    padding: '40px 40px',
    fontWeight: 400,
    fontSize: 15,
    color: '#27282A',
    lineHeight: '22px',
    flex: 1,
    boxShadow: '0 -1px 0 rgba(42, 48, 55, 0.1)',

    '& strong': {
      fontWeight: 600,
    },

    '& p': {
      marginBottom: 16,
    },

    '& ul': {
      listStyleType: 'disc',
      paddingLeft: 18,
      marginBottom: 16,
    },
  },

  link: {
    color: '#148cfc',
    fontSize: 15,
    fontWeight: 500,
    cursor: 'pointer',
  },

  dimTitle: {
    color: '#9badbc',
    fontWeight: 'normal',
    fontSize: 15,
  },

  footer: {
    height: 98,
    background: '#fafbfc',
    borderTop: '1px solid #e1e9f0',
    padding: '23px 40px 27px 40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    position: 'sticky',
    bottom: 0,
    flexShrink: 0,
  },
});

export default styles;
